export const SERVER_URL =
  process.env.NEXT_PUBLIC_SERVER_URL || "http://localhost:3005";

export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SERVER_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export async function responseSnippet(response: Response): Promise<string> {
  return (await response.text().catch(() => "")).slice(0, 200);
}
